/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import { List } from 'immutable';
import UIAlert from 'UIComponents/alert/UIAlert';
import UITable from 'UIComponents/table/UITable';
import UISortTH from 'UIComponents/table/UISortTH';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HubPickerRow from './HubPickerRow';
import I18n from 'I18n';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import H1 from 'UIComponents/elements/headings/H1';
import RequestStatusTypes from 'hub-pickers-lib/constants/RequestStatusTypes';
import links, { redirectLink } from '../utils/links';
import { getAccountsCrossHublet, setPinnedAccounts } from '../Accounts/AccountFetcher';
import { sortByField, sortByNumericalField } from 'hub-pickers-lib/utils/sorts';
import PropTypes from 'prop-types';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class HubPicker extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      accounts: List(),
      accountsRequestStatus: RequestStatusTypes.UNINITIALIZED,
      pinnedAccounts: List(),
      sortField: '',
      sortDir: '',
      hubsFailedToLoad: false,
      crossHublet: false
    };
    this.getFilteredAccounts = () => {
      if (!this.props.filter) {
        return this.state.accounts;
      }
      const filter = this.props.filter.toLowerCase();
      return this.state.accounts.filter(account => account.accountName.toLowerCase().includes(filter) || account.domain.toLowerCase().includes(filter) || account.id.toString().includes(filter));
    };
    this.onSortChange = field => {
      return event => {
        const sortedAccounts = this.state.accounts.sort(sortByField(field, event.target.value));
        this.setState({
          sortDir: event.target.value,
          sortField: field,
          accounts: sortedAccounts
        });
      };
    };
    this.onNumericalSortChange = field => {
      return event => {
        const sortedAccounts = this.state.accounts.sort(sortByNumericalField(field, event.target.value));
        this.setState({
          sortDir: event.target.value,
          sortField: field,
          accounts: sortedAccounts
        });
      };
    };
    this.onPinChange = accountId => {
      const {
        pinnedAccounts
      } = this.state;
      let updatedPinnedAccounts;
      if (pinnedAccounts.includes(accountId)) {
        const index = pinnedAccounts.indexOf(accountId);
        updatedPinnedAccounts = pinnedAccounts.delete(index);
      } else {
        updatedPinnedAccounts = pinnedAccounts.push(accountId);
      }
      setPinnedAccounts(updatedPinnedAccounts).then(resp => {
        this.setState({
          pinnedAccounts: resp
        });
      });
    };
    this.renderLoader = () => {
      return /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: 3,
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {
            grow: true,
            minHeight: 50
          })
        })
      });
    };
    this.renderTableContents = () => {
      const filteredAccounts = this.getFilteredAccounts();
      if (filteredAccounts.size === 0) {
        return /*#__PURE__*/_jsx(NavMarker, {
          name: "EMPTY_TABLE_LOAD",
          children: /*#__PURE__*/_jsx("tr", {
            className: "empty-accounts-table",
            children: /*#__PURE__*/_jsx("td", {
              colSpan: 3,
              children: I18n.text('hubPicker.noFilteredResults')
            })
          })
        });
      }
      const unpinnedAccounts = filteredAccounts.filter(account => !this.state.pinnedAccounts.contains(account.id));
      const pinnedAccountRows = this.state.pinnedAccounts.map((accountId, key) => {
        const account = filteredAccounts.find(filteredAccount => filteredAccount.id === accountId);
        if (!account) {
          return null;
        }
        return /*#__PURE__*/_jsx(HubPickerRow, {
          account: account,
          pinned: true,
          onPinChange: this.onPinChange,
          query: this.props.query,
          redirectTo: this.props.redirectTo
        }, key);
      });
      const unpinnedAccountRows = unpinnedAccounts.map((account, key) => /*#__PURE__*/_jsx(HubPickerRow, {
        account: account,
        pinned: false,
        onPinChange: this.onPinChange,
        query: this.props.query,
        redirectTo: this.props.redirectTo
      }, key));
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "TABLE_LOAD",
        children: [pinnedAccountRows, unpinnedAccountRows]
      });
    };
    this.renderObscuredWarning = () => {
      const {
        accounts
      } = this.state;
      if (accounts.find(account => account.get('obscured')) === undefined) {
        return null;
      }
      return /*#__PURE__*/_jsx(UIAlert, {
        className: "m-bottom-4",
        titleText: I18n.text('hubPicker.obscuredAccounts.title'),
        type: "info",
        children: I18n.text('hubPicker.obscuredAccounts.description')
      });
    };
    this.renderHubsFailedToLoadWarningBanner = () => {
      return /*#__PURE__*/_jsx(UIAlert, {
        className: "m-bottom-4",
        titleText: I18n.text('hubPicker.hubsFailedToLoad'),
        type: "warning"
      });
    };
  }
  componentDidMount() {
    getAccountsCrossHublet(true, false).then(value => {
      this.setState(Object.assign({}, value));
    });
  }
  render() {
    const {
      accounts,
      accountsRequestStatus,
      sortField,
      sortDir,
      hubsFailedToLoad
    } = this.state;
    const {
      shouldWarnAboutObscured
    } = this.props;
    const accountsLoading = accountsRequestStatus === RequestStatusTypes.PENDING || accountsRequestStatus === RequestStatusTypes.UNINITIALIZED;
    const loading = accountsLoading;
    if (accountsRequestStatus === RequestStatusTypes.FAILED) {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest",
        children: /*#__PURE__*/_jsx("p", {
          children: I18n.text('error.requestFailed.description')
        })
      });
    } else if (!loading && accounts.size === 0) {
      return /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        align: "center",
        justify: "center",
        className: "m-top-14 p-top-6",
        gap: "20",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsxs(UIBox, {
          basis: 480,
          className: "m-bottom-6",
          children: [/*#__PURE__*/_jsx(H1, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hubPicker.noPortals.title"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hubPicker.noPortals.descriptionOne"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hubPicker.noPortals.descriptionTwo"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            href: links.signuplink(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hubPicker.noPortals.cta"
            })
          })]
        }), /*#__PURE__*/_jsx(UIBox, {
          basis: 260,
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "team",
            width: "100%"
          })
        })]
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [shouldWarnAboutObscured && this.renderObscuredWarning(), hubsFailedToLoad && this.renderHubsFailedToLoadWarningBanner(), /*#__PURE__*/_jsxs(UITable, {
        className: "account-picker",
        "data-test-id": "account-picker",
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx(UISortTH, {
              className: "name",
              sort: sortField === 'accountName' ? sortDir : 'none',
              onSortChange: this.onSortChange('accountName'),
              children: I18n.text('hubPicker.name')
            }), /*#__PURE__*/_jsx(UISortTH, {
              className: "domain",
              sort: sortField === 'domain' ? sortDir : 'none',
              onSortChange: this.onSortChange('domain'),
              children: I18n.text('hubPicker.domain')
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: loading ? this.renderLoader() : this.renderTableContents()
        })]
      })]
    });
  }
}
HubPicker.propTypes = {
  redirectTo: redirectLink,
  query: PropTypes.object,
  filter: PropTypes.string,
  shouldWarnAboutObscured: PropTypes.bool
};
HubPicker.defaultProps = {
  redirectTo: links.homeService,
  query: {},
  filter: '',
  shouldGetSessions: false,
  shouldWarnAboutObscured: false
};
export default HubPicker;